export default "__VITE_ASSET__7DMkv_7O__"